import React, { useState } from 'react';

interface LogoProps {
  className?: string;
  size?: number;
  title?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '', size = 32, title }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [error, setError] = useState(false);

  const handleLoad = () => {
    setImageLoaded(true);
    setError(false);
  };

  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    setError(true);
    setImageLoaded(false);
  };

  if (error) {
    return (
      <div 
        className={`${className} bg-gray-200 rounded flex items-center justify-center text-gray-400 text-xs`}
        style={{ width: `${size}px`, height: `${size}px` }}
        title={title}
        aria-label="ArchWeaver Logo (error)"
      >
        Logo
      </div>
    );
  }

  return (
    <div className="relative" style={{ width: `${size}px`, height: `${size}px` }}>
      {!imageLoaded && !error && (
        <div 
          className={`${className} bg-gray-100 rounded flex items-center justify-center border border-gray-300 absolute inset-0 z-10`}
          style={{ 
            width: `${size}px`, 
            height: `${size}px`,
          }}
          title={title}
          aria-label="ArchWeaver Logo (loading)"
        >
          <div 
            className="w-3/4 h-3/4 bg-gray-300 rounded animate-pulse"
          />
        </div>
      )}
      <img
        src="/logo.png"
        className={className}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          objectFit: 'contain',
          opacity: imageLoaded ? 1 : 0,
          position: 'relative',
          transition: 'opacity 0.2s ease-in-out',
        }}
        onLoad={handleLoad}
        onError={handleError}
        title={title}
        aria-label="ArchWeaver Logo"
        alt="ArchWeaver Logo"
      />
    </div>
  );
};

export default Logo;
